import { FC, useEffect, useRef, useState } from "react";
import styled, { css, useTheme } from "styled-components";
import {Colors, FInter, FlexBox, Fonts, useBreakpoint} from "@brg/ui";
import {Designer} from "@brg/api";
import { LayoutConst } from "core";


export type AuthorT = Designer<'Local'> & { disabled?: boolean };

export type AuthorActionsT = {
  action: string,
  removedValue?: AuthorT
}

export const SearchInput = styled.input<{ footer?: boolean, isProjectEdit?: boolean, isTeamEdit?: boolean, isPresentationLMS?: boolean }>`
  width: 100%;
  background-color: transparent;
  ${Fonts.Inter.smallText};
  color: ${({ theme }) => theme.projectEdit.mobile.inputs.color};
  outline: none !important;
  border: none;
  border-radius: 3px;
  transition: all 0.2s;
  height: 48px;

  border: 1px solid transparent;

  ::placeholder {
    color: ${({ theme }) => theme.projectEdit.mobile.inputs.placeholder};
    // padding-left: 44px;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ isProjectEdit, isPresentationLMS }) => isProjectEdit ? css`

    height: ${isPresentationLMS ? '32px' : '44px'};

    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
      ::placeholder {
        font-size: 13px;
        line-height: 16px;
        font-weight: 400;
      }
    ` : null};
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ isTeamEdit }) => isTeamEdit ? css`
      height: 40px !important;
    ` : null};
  }

  ${({ isPresentationLMS }) => isPresentationLMS ? css`
      background: ${Colors.geoWhite100};

    @media (max-width: ${LayoutConst.screen.m}px) {
      background: ${Colors.galBlack5};
    }
  ` : null};
`;

export const SearchLine = styled(FlexBox)`
  background: ${(p) => p.theme.navigationBar.search.line};
  height: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

//todo remove static height

export const SearchWrapper = styled(FlexBox)<{ out?: boolean, footer?: boolean, isOpen?: boolean, isLMS?: boolean }>`
  align-items: center;
  height: 48px;
  margin-left: 0;
  position: relative;
  width: 100%;
  border-radius: ${({ isOpen }) => isOpen ? '3px 3px 0 0' : '3px'};
  background-color: ${({ theme }) => theme.mainSearchBar.bg};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
`;

export const SearchFlexBox = styled(FlexBox)<{footer?: boolean}>`
  height: 48px;
  position: relative;
  align-items: center;
  color: ${(p) => p.theme.navigationBar.search.colorFlex};
  width: 100%;
`;

export const NavbarSearchWrapper = styled.div<{footer?: boolean, isPresentationLMS?: boolean}>`
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
  // opacity: 0.47;
  transition: opacity 0.2s;
  align-items: center;
  justify-content: center;
  place-items: center;
  height: 100%;

  svg {
    * {
      fill: ${(p) => p.theme.navigationBar.search.svg} !important;
    }
  }
  &:hover {
    svg {
      * {
        fill: ${(p) => p.theme.navigationBar.search.svgHover} !important;
      }
    }
  }

  svg {
    width: ${({footer}) => footer ? '14' : '16'}px !important;
    height: ${({footer}) => footer ? '14' : '16'}px !important;
  }
`;

export const NavbarResultsWrapper = styled.div<{footer?: boolean, isLMS?: boolean}>`
  // position: absolute;
  background-color: ${(p) => p?.isLMS ? '#FEFEFE' : p.theme.mainSearchBar.input.bg};
  max-height: 200px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12);
  margin-bottom: 50px;

  ::-webkit-scrollbar {
    width: 3px; /* ширина scrollbar */
    height: 68px;
  }
  ::-webkit-scrollbar-track {
      background: transparent; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 10px; /* закругления плашки */
      background-color: ${({ theme }) => theme.scroll.bg};
  }

  .save-msg {
    font-size: 17px;
    line-height: 22px;

    * {
      color: ${(p) => p.theme.educationSearchBar.result.color};
    }

    span:last-child {
      text-decoration: underline;
    }
  }
`;

export const NavbarResultsItem = styled.div<{ isSelected?: boolean, isLMS?: boolean }>`
  display: flex;
  width: 100%;
  height: 46px;
  cursor: pointer;
  padding: 12px 16px;
  transition: background-color 0.2s;
  background-color: ${(p) => p?.isLMS ? '#FEFEFE' : p.theme.mainSearchBar.input.bg};

  :not(.save-msg) {
    :hover {
      background-color: ${(p) => p.theme.app.ten};
    }
    :active {
      background-color: ${Colors.galBlack31};
    }
  }

  .check-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
`;

const DropWrapper = styled.div<{ orientation?: string, isLMS?: boolean }>`
  position: absolute;
  top: 40px;
  left: 0;
  height: auto;
  width: 100%;
  z-index: 400;

  .search-msg {
    color: ${({ theme }) => theme.projectEdit.mobile.inputs.color};
    ${({ isLMS }) => isLMS && css`
      background-color: #FEFEFE;
    `};
  }

  .item {
    :not(.search-msg) {
      :hover {
        background-color: ${({ theme, isLMS }) => isLMS ? '#F2F2F2' : theme.mainSearchBar.text.hover.color};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    top: 40px;
  }

  // @media(max-width: ${LayoutConst.screen.l_16}px) {
  //     width: 295px;
  // }


  // @media(max-width: ${LayoutConst.screen.m_1024}px) {
  //   width: 304px;
  // }

`;

const InputWrapper = styled(FlexBox)<{isPresentationLMS?: boolean}>`
  position: relative;
  width: 100%;

  svg path {
    cursor: pointer;
    fill: ${Colors.galBlack47};
    transition: color 0.2s;
  }
  .close-btn-wrap {
    &:hover {
      svg path {
        fill: ${Colors.galBlack100};
        transition: color 0.2s;
      }
    }
  }

  input {
    max-width: 700px;
    width: 700px;
    padding: 0 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-width: 564px;
      width: 564px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
      max-width: none;
      width: 100%;
      min-width: 100%;
    }
  }

`;

const Text = styled(FInter.SmallTextDiv)`
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.02em;
`;

const ArrowWrapper = styled(FlexBox)<{ isOpen: boolean }>`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.2s;
  cursor: pointer;

  svg path {
    fill: #909090;
  }

  ${({ isOpen }) => isOpen && css`
    transform: rotate(180deg) translateY(-35%);
    top: 35%;
    transition: transform 0.2s;
  `};
`;

const ArrowIcon: FC<{ isOpen: boolean }> = ({ isOpen }) => (
  <ArrowWrapper isOpen={isOpen}>
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 6.15801L1.25981 0.223468C0.971612 -0.0744925 0.504346 -0.0744886 0.216147 0.223475C-0.0720515 0.52144 -0.0720488 1.00453 0.216154 1.30249L6.47817 7.77653C6.76637 8.07449 7.23363 8.07449 7.52183 7.77653L13.7838 1.30249C14.072 1.00453 14.0721 0.52144 13.7839 0.223475C13.4957 -0.0744886 13.0284 -0.0744925 12.7402 0.223468L7 6.15801Z"
          fill='#909090'/>
    </svg>
  </ArrowWrapper>
)
 
export interface MainMenuSearchBarProps {
  editing: boolean;
  onAddClick: (id: string) => void;
  onChooseClick: (value: string) => void
  onSelect?: (id: string) => boolean;
  onValueChange?: (id: any) => void;
  onChange?: (ev: any) => void;
  isProjectEdit?: boolean;
  teamId?: string;
  isTeamEdit?: boolean;
  isLMS?: boolean;
  isPresentationLMS?: boolean;
  placeholder?: string;
  currentValue?: string;
  valueList: string[];
}

export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(deps || []), delay]);
};

export const DamuseumDropdown: FC<MainMenuSearchBarProps> = ({
  editing = false, 
  isPresentationLMS, 
  placeholder,
  currentValue,
  valueList, 
  onValueChange,
  onChange,
  ...rest
}) => {
  const searchRef = useRef<any>(null);
  const resultRef = useRef<any>(null);
  const theme = useTheme();
  const is568px = useBreakpoint(568)
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (searchRef && editing && !is568px) {
      searchRef.current?.focus();
    }
  }, [searchRef, editing])

  const resetOpen = () => {
    setOpen(false);
  }

  const handleAddClick = (data: string ) => {
    onChange && onChange({ target: {value : data}})
    onValueChange && onValueChange(data)
    resetOpen(); 
  }

  const handleClose = (ev: any) => {
    if (searchRef?.current && !searchRef?.current?.contains(ev?.target) && typeof ev?.target?.className === 'string' && !ev?.target?.className?.includes('save-education-center')) {
        resetOpen();
    }
  }

  useEffect(() => {
    window.addEventListener('click', handleClose)
    return () => {
      window.removeEventListener('click', handleClose)
    }
  }, [])

  return (
    <SearchFlexBox className={'search-wrapper'}>
      <SearchWrapper isOpen={isOpen}>
        <InputWrapper onClick={() => setOpen(!isOpen)} className="input-wrapper" direction="row" directionMobile="row" align="center" alignMobile='center' isPresentationLMS={isPresentationLMS}>
            <SearchInput
                ref={searchRef}
                onClick={() => setOpen(true)}
                placeholder={placeholder}
                value={currentValue}
                style={{ caretColor: 'transparent'}}
                {...rest}
            />
            <ArrowIcon isOpen={isOpen}/>
        </InputWrapper>
          {isOpen ? (
            <DropWrapper>
                <NavbarResultsWrapper ref={resultRef}>
                    {valueList.map((v, idx) => {
                    return (
                        <NavbarResultsItem
                        isLMS={isPresentationLMS}
                        onClick={() => {
                            handleAddClick(v)
                        }}
                        key={idx}
                        style={{ marginBottom: '4px' }}
                        className={'item'}
                        >
                        <FlexBox align={"center"} gx={8} style={{ padding: "2px 0 2px 9px", position: 'relative' }} width={'100%'}>
                            <Text color={theme.mainSearchBar.text.color}>{v}</Text>
                            {currentValue === v && (
                            <svg className={'check-icon'} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7589 5.22636C13.0803 5.52689 13.0803 6.01832 12.7589 6.32014L6.92932 11.773C6.76865 11.9239 6.55856 12 6.34708 12C6.13697 12 5.92682 11.9239 5.76614 11.773L3.24204 9.42346C2.91932 9.12293 2.91932 8.63151 3.24204 8.32969C3.56339 8.02787 4.08387 8.02787 4.40522 8.32969L6.34708 10.1311L11.5944 5.22636C11.9157 4.92455 12.4362 4.92455 12.7589 5.22636Z" fill={theme.mainSearchBar.text.color || '#151514'} />
                            </svg>
                            )}
                        </FlexBox>
                        </NavbarResultsItem>
                    );
                    })}
                
                </NavbarResultsWrapper>
            </DropWrapper>
        ) : null}
      </SearchWrapper>
    </SearchFlexBox>
  );
};
import { FC, useEffect, useRef, useState } from "react";
import styled, { css, useTheme } from "styled-components";
import {Colors, FInter, FlexBox, Fonts, useBreakpoint} from "@brg/ui";
import {Designer} from "@brg/api";
import { LayoutConst } from "core";


export type AuthorT = Designer<'Local'> & { disabled?: boolean };

export type AuthorActionsT = {
  action: string,
  removedValue?: AuthorT
}

export const SearchInput = styled.input<{ footer?: boolean, isProjectEdit?: boolean, isTeamEdit?: boolean, isPresentationLMS?: boolean }>`
  width: 100%;
  background-color: transparent;
  ${Fonts.Inter.smallText};
  color: ${({ theme }) => theme.projectEdit.mobile.inputs.color};
  outline: none !important;
  border: none;
  border-radius: 3px;
  transition: all 0.2s;
  height: 48px;

  border: 1px solid transparent;

  ::placeholder {
    color: ${({ theme }) => theme.projectEdit.mobile.inputs.placeholder};
    // padding-left: 44px;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ isProjectEdit, isPresentationLMS }) => isProjectEdit ? css`

    height: ${isPresentationLMS ? '32px' : '44px'};

    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
      ::placeholder {
        font-size: 13px;
        line-height: 16px;
        font-weight: 400;
      }
    ` : null};
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ isTeamEdit }) => isTeamEdit ? css`
      height: 40px !important;
    ` : null};
  }

  ${({ isPresentationLMS }) => isPresentationLMS ? css`
      background: ${Colors.geoWhite100};

    @media (max-width: ${LayoutConst.screen.m}px) {
      background: ${Colors.galBlack5};
    }
  ` : null};
`;

export const SearchLine = styled(FlexBox)`
  background: ${(p) => p.theme.navigationBar.search.line};
  height: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

//todo remove static height

export const SearchWrapper = styled(FlexBox)<{ out?: boolean, footer?: boolean, isOpen?: boolean, isLMS?: boolean }>`
  align-items: center;
  height: 48px;
  margin-left: 0;
  position: relative;
  width: 100%;
  border-radius: ${({ isOpen }) => isOpen ? '3px 3px 0 0' : '3px'};
  background-color: ${({ theme }) => theme.mainSearchBar.bg};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
`;

export const SearchFlexBox = styled(FlexBox)<{footer?: boolean}>`
  height: 48px;
  position: relative;
  align-items: center;
  color: ${(p) => p.theme.navigationBar.search.colorFlex};
  width: 100%;
`;

export const NavbarSearchWrapper = styled.div<{footer?: boolean, isPresentationLMS?: boolean}>`
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
  // opacity: 0.47;
  transition: opacity 0.2s;
  align-items: center;
  justify-content: center;
  place-items: center;
  height: 100%;

  svg {
    * {
      fill: ${(p) => p.theme.navigationBar.search.svg} !important;
    }
  }
  &:hover {
    svg {
      * {
        fill: ${(p) => p.theme.navigationBar.search.svgHover} !important;
      }
    }
  }

  svg {
    width: ${({footer}) => footer ? '14' : '16'}px !important;
    height: ${({footer}) => footer ? '14' : '16'}px !important;
  }
`;

export const NavbarResultsWrapper = styled.div<{footer?: boolean, isLMS?: boolean}>`
  // position: absolute;
  background-color: ${(p) => p?.isLMS ? '#FEFEFE' : p.theme.mainSearchBar.input.bg};
  max-height: 200px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12);
  margin-bottom: 50px;

  ::-webkit-scrollbar {
    width: 3px; /* ширина scrollbar */
    height: 68px;
  }
  ::-webkit-scrollbar-track {
      background: transparent; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 10px; /* закругления плашки */
      background-color: ${({ theme }) => theme.scroll.bg};
  }

  .save-msg {
    font-size: 17px;
    line-height: 22px;

    * {
      color: ${(p) => p.theme.educationSearchBar.result.color};
    }

    span:last-child {
      text-decoration: underline;
    }
  }
`;

export const NavbarResultsItem = styled.div<{ isSelected?: boolean, isLMS?: boolean }>`
  display: flex;
  width: 100%;
  height: 46px;
  cursor: pointer;
  padding: 12px 16px;
  transition: background-color 0.2s;
  background-color: ${(p) => p?.isLMS ? '#FEFEFE' : p.theme.mainSearchBar.input.bg};

  :not(.save-msg) {
    :hover {
      background-color: ${(p) => p.theme.app.ten};
    }
    :active {
      background-color: ${Colors.galBlack31};
    }
  }

  .check-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
`;

const DropWrapper = styled.div<{ orientation?: string, isLMS?: boolean }>`
  position: absolute;
  top: 40px;
  left: 0;
  height: auto;
  width: 100%;
  z-index: 400;

  .search-msg {
    color: ${({ theme }) => theme.projectEdit.mobile.inputs.color};
    ${({ isLMS }) => isLMS && css`
      background-color: #FEFEFE;
    `};
  }

  .item {
    :not(.search-msg) {
      :hover {
        background-color: ${({ theme, isLMS }) => isLMS ? '#F2F2F2' : theme.mainSearchBar.text.hover.color};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    top: 40px;
  }

  // @media(max-width: ${LayoutConst.screen.l_16}px) {
  //     width: 295px;
  // }


  // @media(max-width: ${LayoutConst.screen.m_1024}px) {
  //   width: 304px;
  // }

`;

const InputWrapper = styled(FlexBox)<{isPresentationLMS?: boolean}>`
  position: relative;
  width: 100%;

  svg path {
    cursor: pointer;
    fill: ${Colors.galBlack47};
    transition: color 0.2s;
  }
  .close-btn-wrap {
    &:hover {
      svg path {
        fill: ${Colors.galBlack100};
        transition: color 0.2s;
      }
    }
  }

  input {
    max-width: 700px;
    width: 700px;
    padding: 0 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-width: 564px;
      width: 564px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
      max-width: none;
      width: 100%;
      min-width: 100%;
    }
  }

`;

const Text = styled(FInter.SmallTextDiv)`
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.02em;
`;

const ArrowWrapper = styled(FlexBox)<{ isOpen: boolean }>`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.2s;
  cursor: pointer;

  svg path {
    fill: #909090;
  }

  ${({ isOpen }) => isOpen && css`
    transform: rotate(180deg) translateY(-35%);
    top: 35%;
    transition: transform 0.2s;
  `};
`;

const ArrowIcon: FC<{ isOpen: boolean }> = ({ isOpen }) => (
  <ArrowWrapper isOpen={isOpen}>
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 6.15801L1.25981 0.223468C0.971612 -0.0744925 0.504346 -0.0744886 0.216147 0.223475C-0.0720515 0.52144 -0.0720488 1.00453 0.216154 1.30249L6.47817 7.77653C6.76637 8.07449 7.23363 8.07449 7.52183 7.77653L13.7838 1.30249C14.072 1.00453 14.0721 0.52144 13.7839 0.223475C13.4957 -0.0744886 13.0284 -0.0744925 12.7402 0.223468L7 6.15801Z"
          fill='#909090'/>
    </svg>
  </ArrowWrapper>
)
 
export interface MainMenuSearchBarProps {
  editing: boolean;
  onAddClick: (id: string) => void;
  onChooseClick: (value: string) => void
  onSelect?: (id: string) => boolean;
  onValueChange?: (id: any) => void;
  onChange?: (ev: any) => void;
  isProjectEdit?: boolean;
  teamId?: string;
  isTeamEdit?: boolean;
  isLMS?: boolean;
  isPresentationLMS?: boolean;
  placeholder?: string;
  currentValue?: string;
  valueList: string[];
}

export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(deps || []), delay]);
};

export const DamuseumDropdown: FC<MainMenuSearchBarProps> = ({
  editing = false, 
  isPresentationLMS, 
  placeholder,
  currentValue,
  valueList, 
  onValueChange,
  onChange,
  ...rest
}) => {
  const searchRef = useRef<any>(null);
  const resultRef = useRef<any>(null);
  const theme = useTheme();
  const is568px = useBreakpoint(568)
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (searchRef && editing && !is568px) {
      searchRef.current?.focus();
    }
  }, [searchRef, editing])

  const resetOpen = () => {
    setOpen(false);
  }

  const handleAddClick = (data: string ) => {
    onChange && onChange({ target: {value : data}})
    onValueChange && onValueChange(data)
    resetOpen(); 
  }

  const handleClose = (ev: any) => {
    if (searchRef?.current && !searchRef?.current?.contains(ev?.target) && typeof ev?.target?.className === 'string' && !ev?.target?.className?.includes('save-education-center')) {
        resetOpen();
    }
  }

  useEffect(() => {
    window.addEventListener('click', handleClose)
    return () => {
      window.removeEventListener('click', handleClose)
    }
  }, [])

  return (
    <SearchFlexBox className={'search-wrapper'}>
      <SearchWrapper isOpen={isOpen}>
        <InputWrapper onClick={() => setOpen(!isOpen)} className="input-wrapper" direction="row" directionMobile="row" align="center" alignMobile='center' isPresentationLMS={isPresentationLMS}>
            <SearchInput
                ref={searchRef}
                onClick={() => setOpen(true)}
                placeholder={placeholder}
                value={currentValue}
                style={{ caretColor: 'transparent'}}
                {...rest}
            />
            <ArrowIcon isOpen={isOpen}/>
        </InputWrapper>
          {isOpen ? (
            <DropWrapper>
                <NavbarResultsWrapper ref={resultRef}>
                    {valueList.map((v, idx) => {
                    return (
                        <NavbarResultsItem
                        isLMS={isPresentationLMS}
                        onClick={() => {
                            handleAddClick(v)
                        }}
                        key={idx}
                        style={{ marginBottom: '4px' }}
                        className={'item'}
                        >
                        <FlexBox align={"center"} gx={8} style={{ padding: "2px 0 2px 9px", position: 'relative' }} width={'100%'}>
                            <Text color={theme.mainSearchBar.text.color}>{v}</Text>
                            {currentValue === v && (
                            <svg className={'check-icon'} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7589 5.22636C13.0803 5.52689 13.0803 6.01832 12.7589 6.32014L6.92932 11.773C6.76865 11.9239 6.55856 12 6.34708 12C6.13697 12 5.92682 11.9239 5.76614 11.773L3.24204 9.42346C2.91932 9.12293 2.91932 8.63151 3.24204 8.32969C3.56339 8.02787 4.08387 8.02787 4.40522 8.32969L6.34708 10.1311L11.5944 5.22636C11.9157 4.92455 12.4362 4.92455 12.7589 5.22636Z" fill={theme.mainSearchBar.text.color || '#151514'} />
                            </svg>
                            )}
                        </FlexBox>
                        </NavbarResultsItem>
                    );
                    })}
                
                </NavbarResultsWrapper>
            </DropWrapper>
        ) : null}
      </SearchWrapper>
    </SearchFlexBox>
  );
};
